export enum ActiveStatus {
    Active = 1,
    InActive = 2
}